import styled, { keyframes } from "styled-components";

/*
 * Newsletter preferencije, novi stil (v2), po šablonu TShirtSizeGuide /
 * ConfirmModal: header red sa border-bottom, telo koje skroluje, footer red
 * sa border-top (napomena levo, akcije desno). Ikonice u brand-dim pločicama,
 * checkbox desno; checked stanje = narandžasta ivica + blaga nijansa.
 */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const ModalContainer = styled.div`
  background: var(--bg-surface);
  border: 1px solid var(--border-strong);
  border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
  max-width: 500px;
  width: 100%;
  max-height: 92dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.4rem;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;

  h3 {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    margin: 0;
    color: var(--text-primary);
    font-size: 1.05rem;
    font-weight: 700;

    svg {
      color: var(--brand);
      flex-shrink: 0;
    }
  }
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  color: #a6a6a6;
  border: 1px solid var(--border);
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: var(--text-primary);
  }
`;

export const ModalContent = styled.div`
  padding: 1.4rem;
  overflow-y: auto;

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

export const EmailDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.6rem 0.9rem;
  background: var(--bg-surface-2);
  border: 1px solid var(--border);
  border-radius: 8px;
  margin-bottom: 1.25rem;

  svg {
    color: var(--text-muted);
    flex-shrink: 0;
  }

  span {
    color: var(--text-primary);
    font-size: 0.9rem;
    overflow-wrap: anywhere;
  }
`;

export const PreferencesSection = styled.div``;

export const PreferencesHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.7rem;
`;

export const PreferencesTitle = styled.h4`
  margin: 0;
  color: var(--text-primary);
  font-size: 0.95rem;
  font-weight: 700;
`;

export const SelectAllButton = styled.button`
  height: 30px;
  padding: 0 0.75rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text-secondary);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: var(--text-primary);
  }

  &.selected {
    color: var(--brand);
    background: var(--brand-dim);
    border-color: rgba(255, 107, 53, 0.35);
  }
`;

export const CheckboxGroup = styled.div`
  display: grid;
  gap: 0.5rem;
`;

export const CheckboxItem = styled.label`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0.85rem;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: var(--border-strong);
    background: rgba(255, 255, 255, 0.04);
  }

  &.checked {
    border-color: rgba(255, 107, 53, 0.45);
    background: rgba(255, 107, 53, 0.06);
  }
`;

/* Ikonica u brand-dim pločici, kao LetterBadge u vodiču za veličine */
export const CheckboxIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: var(--radius-control);
  background: var(--brand-dim);
  border: 1px solid rgba(255, 107, 53, 0.35);
  color: var(--brand);
`;

export const CheckboxContent = styled.div`
  flex: 1;
  min-width: 0;

  h5 {
    margin: 0 0 2px;
    color: var(--text-primary);
    font-size: 0.9rem;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: var(--text-secondary);
    font-size: 0.8rem;
    line-height: 1.45;
  }
`;

/* Pravi input je vizuelno sakriven (ostaje fokusabilan za tastaturu),
   a kućicu crta CheckIndicator sa FiCheck ikonicom, pouzdano u svim
   browserima, bez appearance/pseudo-element trikova */
export const CustomCheckbox = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  clip: rect(0 0 0 0);
  overflow: hidden;
  white-space: nowrap;
`;

export const CheckIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border: 1px solid var(--border-strong);
  border-radius: 5px;
  background: transparent;
  transition: all 0.15s ease;

  svg {
    opacity: 0;
    color: #ffffff;
    transition: opacity 0.12s ease;
  }

  ${CustomCheckbox}:checked + & {
    background: var(--brand);
    border-color: var(--brand);

    svg {
      opacity: 1;
    }
  }

  ${CustomCheckbox}:focus-visible + & {
    outline: 2px solid rgba(255, 107, 53, 0.6);
    outline-offset: 2px;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.65rem 0.9rem;
  margin-bottom: 1.25rem;
  background: rgba(220, 53, 69, 0.12);
  border: 1px solid rgba(220, 53, 69, 0.35);
  border-radius: 8px;
  color: var(--danger);
  font-size: 0.85rem;

  svg {
    flex-shrink: 0;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.4rem;
  border-top: 1px solid var(--border);
  flex-shrink: 0;

  @media (max-width: 480px) {
    flex-direction: column-reverse;
    align-items: stretch;
    padding: 1rem;
  }
`;

export const FooterNote = styled.p`
  margin: 0;
  color: var(--text-muted);
  font-size: 0.76rem;
  line-height: 1.45;
  max-width: 220px;

  @media (max-width: 480px) {
    max-width: none;
    text-align: center;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 0.6rem;
  flex-shrink: 0;

  @media (max-width: 480px) {
    & > button {
      flex: 1;
    }
  }
`;

export const ModalButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  height: 42px;
  padding: 0 1.1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.88rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.18s ease;

  &.secondary {
    background: rgba(255, 255, 255, 0.08);
    color: #f1f1f1;
    border: 1px solid rgba(255, 255, 255, 0.16);

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.14);
    }
  }

  &.primary {
    background: var(--brand);
    color: #ffffff;
    border: none;

    &:hover:not(:disabled) {
      background: var(--brand-hover);
    }
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    flex-shrink: 0;
  }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const ButtonSpinner = styled.span`
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;
